import React from 'react'

/**
 * Placeholder layout while company details load. Mirrors IdentityBar +
 * tab bar + first panel so the page does not jump as hard when data arrives.
 */
const CompanyProfileSkeleton: React.FC = () => (
  <div
    data-testid="company-profile-skeleton"
    className="mt-3 animate-pulse"
    aria-busy="true"
    aria-label="Henter virksomhedsdata"
  >
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mb-2">
      <div className="h-3 w-24 rounded-sm bg-rule" />
      <div className="h-3 w-40 rounded-sm bg-rule" />
      <div className="h-7 w-28 rounded-sm bg-rule" />
    </div>

    <div className="flex flex-wrap gap-x-4 gap-y-1.5">
      <div className="h-4 w-28 rounded-sm bg-rule" />
      <div className="h-4 w-32 rounded-sm bg-rule" />
      <div className="h-4 w-24 rounded-sm bg-rule" />
    </div>

    <div className="mt-3 border-b border-rule pb-2">
      <div className="h-9 sm:h-11 max-w-xl w-full rounded-sm bg-rule" />
      <div className="mt-2 flex flex-wrap gap-x-6 gap-y-1" aria-hidden>
        {[72, 88, 76, 68].map((w) => (
          <div key={w} className="h-4 rounded-sm bg-rule" style={{ width: w }} />
        ))}
      </div>
    </div>

    <div className="mt-4 space-y-2" aria-hidden>
      <div className="h-3 w-40 rounded-sm bg-rule" />
      <div className="h-16 w-full rounded-sm bg-rule" />
      <div className="h-3 w-36 rounded-sm bg-rule mt-4" />
      <div className="h-14 w-full rounded-sm bg-rule" />
      <div className="h-3 w-44 rounded-sm bg-rule mt-4" />
      <div className="h-14 w-full rounded-sm bg-rule" />
    </div>
  </div>
)

export default CompanyProfileSkeleton
